module.exports = __webpack_public_path__ + "img/right-bach.d17a85ad.png";